module.exports = __webpack_public_path__ + "static/media/Savage.5d5f0c72.jpg";